<template>
    <div class="container-fluid projects__section">

        <div v-for="project in projects" :key="project.id" class="row projects__item">
            <div class="col-md-6">
                <img class="projects__item__image" :src="project.coverPhoto.path" alt="">
            </div>
            <div class="col-md-6 projects__item__aside">
                <div class="projects__item__content">
                    <span class="tag bg--secondary">{{ project.status }}</span>
                    <h2>{{ project.title }}</h2>
                    <strong class="st-date" v-text="project.end"></strong>
                    <p class="line-clamp">{{ project.intro }}</p>
                    <a :href="'/projecten/' + project.slug" class="btn hover-text--primary hover-border--primary">Lees meer</a>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
    export default{
        props:{
            'projects': {required: true}
        },
    }
</script>
<style>

</style>
